<template>
  <div>
    <data-list :payload="warehouseDataObj" class="mt-3" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="warehouseLocObj" ref="warehouseLocReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      warehouseLocObj: { isactive: true, isdefault: false },
      warehouseDataObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleWarehouseHandler
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.WAREHOUSE_LOCATION) ? this.$store.state.WAREHOUSE_LOCATION : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' }
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '30%'
      }, {
        text: this.$t('message.layout.warehouse'),
        value: 'warehouse_name',
        sortable: true,
        width: '30%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }]
    },
    ...mapState(['FORM_TYPE', 'listOfWarehouse']),
    formReferences () {
      return {
        title: this.warehouseLocObj.id ? this.$t('message.warehouse.updateLocation') : this.$t('message.warehouse.addLocation'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, {
          model: 'warehouseid',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.AUTO_COMPLETE,
          class: 'xs6',
          is_list: true,
          click: (term) => this.supportingList(this.WAREHOUSE, term),
          term: 'warehouse',
          items: this.listOfWarehouse,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse')
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.warehouseLocObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = {
          type: 'WAREHOUSE_LOCATION',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.WAREHOUSELOCATION) {
        const payload = { ids: data.ids, url: `${this.WAREHOUSELOCATION}/delete_multiple`, module: 'warehouselocations' }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.WAREHOUSELOCATION) {
        this.warehouseDataObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$store.dispatch('getWarehouse')
  },
  methods: {
    getListHandler () {
      this.warehouseDataObj.loading = true
      this.warehouseDataObj.module = this.WAREHOUSELOCATION
      const fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(1, 1)
      const queryFields = fields
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const sort = queryFields.find(x => x.value === sortBy[0])
      const query = {
        expand: [{
          select: ['name'],
          model: 'Warehouse',
          on_field: 'id',
          on_parent_field: 'warehouseid',
          filter: `name contains '${search}'`,
          order_by: {
            field: sortBy[0] === 'warehouse_name' ? 'name' : null,
            asc_or_desc: sortBy[0] === 'warehouse_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }
        ],
        order_by: {
          field: sort ? sort.value : null,
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', 'warehouselocations/query', query)
        .then((response) => {
          const { values, count } = response.data
          this.warehouseDataObj.loading = false
          this.warehouseDataObj.list = values
          this.total = count
        })
    },
    supportingList (type, text) {
      text = this.$refs.warehouseLocReference.$refs[text][0].lazySearch
      const model = { module: type, dialog: true, text }
      this.$store.commit('supportingList', model)
    },
    getSingleWarehouseHandler (id) {
      this.$_getSingleRecordHandler(`warehouselocations/${id}`)
        .then((result) => {
          if (result.data) this.warehouseLocObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.warehouseLocObj.isactive = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.warehouseLocObj.id = undefined
      this.$refs.warehouseLocReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.warehouseLocReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.warehouseLocObj
        const url = 'warehouselocations'
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
